// src/features/AdminDashboard/reports/utils/reportDate.utils.ts


// ============================================================
// GET TODAY DATE
// ============================================================
//
// Returns local browser date.
//
// Example:
// 06 October 2026
//
// returns:
//
// 2026-10-06
//
// ============================================================

export const getTodayDate = (): string => {

  const today =
    new Date();


  const year =
    today.getFullYear();


  const month =
    String(
      today.getMonth() + 1,
    ).padStart(
      2,
      '0',
    );


  const day =
    String(
      today.getDate(),
    ).padStart(
      2,
      '0',
    );


  return `${year}-${month}-${day}`;
};